"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var Icon = function Icon(props) {
  var type = props.type,
      variant = props.variant,
      className = props.className,
      others = (0, _objectWithoutProperties2.default)(props, ["type", "variant", "className"]);

  var _className = (0, _classnames2.default)(className, 'Icon', "Icon--".concat(type), (0, _defineProperty2.default)({}, "Icon--".concat(variant), !!variant));

  return React.createElement("i", Object.assign({}, others, {
    className: _className,
    "aria-hidden": "true"
  }));
};

Icon.defaultProps = {
  className: '',
  variant: undefined
};
var _default = Icon;
exports.default = _default;